<template>
  <div class="create">
    <info-panel :padding="24">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="90px"
      >
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item
              label="测评宝ICON标签"
              prop="evaluationIconTag"
              label-width="120px"
            >
              <el-input
                v-model="createForm.evaluationIconTag"
                type="textarea"
              />
              <!-- <editor :html.sync="createForm.evaluationIconTag" /> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
    <el-row
      :gutter="20"
      class="submit"
    >
      <el-col class="btns">
        <el-button @click="cancel">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="submit"
        >
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axClient from '@/services';
import infoPanel from '@/components/common/infoPanel.vue';
// import Editor from '@/components/common/editor.vue';

export default {
  name: 'AgencyEdit',
  components: {
    infoPanel,
    // Editor,
  },
  data() {
    return {
      createForm: {
        evaluationIconTag: '',
      },
      creatRules: {
        evaluationIconTag: [
          { required: false, message: '请输入测评宝ICON标签', trigger: 'blur' },
        ],
      },
      isEditType: !!this.$route.params.id,
    };
  },
  mounted() {
    this.isEdit();
  },
  methods: {
    // 取消
    cancel() {
      window.history.back();
    },
    // 提交
    async submit() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.config.updateEvaluationIconTagNotice(this.createForm);
          if (data) {
            this.$message.success('编辑测评宝ICON标签成功');
            this.$router.push({ name: 'ConfigEvaluation' });
          }
        }
      });
    },
    // 是否编辑信息
    async isEdit() {
      const { evaluationIconTag } = await axClient.config.getEvaluationIconTagNotice();
      this.createForm = {
        evaluationIconTag,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.submit {
  margin-top: 20px;
  text-align: center;
}
</style>